import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-community/styles/ag-theme-alpine.css";
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import DailyReportsServices from '../../services/axiosServices/apiServices/DailyReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { isValidForm } from '../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../utils/Messages';
import { getFinancialYearDates } from '../../utils/DateUtils';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class AccountStockReport extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            rowData: [
                // { item_type: "Raw Material", group: "Metals", item_category: "Steel", drawing_no: "DRW-001", item_name: "Steel Rod", stock_rate: 120.5, store_qty: 50, stock_amount: 6025 },
                // { item_type: "Component", group: "Electronics", item_category: "Resistor", drawing_no: "DRW-002", item_name: "100Ω Resistor", stock_rate: 0.5, store_qty: 5000, stock_amount: 2500 },
                // { item_type: "Finished Product", group: "Machinery", item_category: "Gearbox", drawing_no: "DRW-003", item_name: "Heavy Duty Gearbox", stock_rate: 5000, store_qty: 10, stock_amount: 50000 },
                // { item_type: "Raw Material", group: "Plastics", item_category: "Polymer", drawing_no: "DRW-004", item_name: "ABS Granules", stock_rate: 80, store_qty: 100, stock_amount: 8000 },
                // { item_type: "Component", group: "Fasteners", item_category: "Bolts", drawing_no: "DRW-005", item_name: "Hex Bolt M8", stock_rate: 2, store_qty: 2000, stock_amount: 4000 },
            ],
            colDefs: [
                {
                    field: "itemType",
                    headerName: "Item type",
                    rowGroup: true,
                    filter: true,
                    floatingFilter: true,
                    width: window.innerWidth * 0.09,
                    pinned: "left"
                },
                {
                    field: "group",
                    headerName: "Group",
                    filter: true,
                    floatingFilter: true,
                    width: window.innerWidth * 0.1,
                    pinned: "left"
                },
                {
                    field: "itemCategory",
                    headerName: "Item category",
                    filter: true,
                    floatingFilter: true,
                    width: window.innerWidth * 0.09,
                    pinned: "left"
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing no",
                    filter: true,
                    floatingFilter: true,
                    width: window.innerWidth * 0.11,
                    pinned: "left"
                },
                {
                    field: "itemName",
                    headerName: "Item name",
                    filter: true,
                    floatingFilter: true,
                    width: window.innerWidth * 0.2,
                    pinned: "left"
                },
                {
                    field: "stockRate",
                    headerName: "Stock rate",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.06,
                    flex: 1,
                },
                {
                    field: "storeQty",
                    headerName: "Store qty",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.05,
                    flex: 1,
                },
                {
                    field: "stockAmount",
                    headerName: "Stock amount",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.06,
                    flex: 1,
                    valueGetter: (params) => {
                        if (!params.data) return null;
                        // pinned total row already holds the summed amount
                        if (params.node && params.node.rowPinned) return params.data.stockAmount;
                        return this.calculateStockAmount(params.data);
                    },
                },
            ],
            rowHeight: 40,
            idCompany: 0,
            isLoading: false,
            requestDetails: {
                fromDate: "",
                toDate: "",
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
            }
        };
        this.gridApi = null;
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.requestDetails;
        if (name === "fromDate") {
            details[name] = value
        } else {
            details[name] = value
        }
        this.setState({ requestDetails: details });
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                //this.procItemStockRegisterWithTotalAmount_ForAccount();
            });
        } else {
            //window.location.href = "/Login";
        }
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
        window.addEventListener("resize", this.handleResize);

        let details = this.state.requestDetails
        details.fromDate = getFinancialYearDates().fromDate;
        details.toDate = getFinancialYearDates().toDate;
        this.setState({ requestDetails: details })
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    componentDidUpdate(prevState) {
        if (prevState.rowData !== this.state.rowData) {
            const newSumRow = this.calculateSumRow();
            if (JSON.stringify(this.state.sumRow) !== JSON.stringify(newSumRow)) {
                this.setState({ sumRow: newSumRow });
            }
        }
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    calculateStockAmount = (row) => {
        const rate = Number(row.stockRate) || 0;
        const qty = Number(row.storeQty) || 0;
        return Number((rate * qty).toFixed(2));
    };

    calculateSumRow = () => {
        const rowData = this.state.rowData || [];
        return {
            itemType: "Total",
            storeQty: rowData.reduce((sum, row) => sum + (Number(row.storeQty) || 0), 0),
            stockAmount: Number(rowData.reduce((sum, row) => sum + this.calculateStockAmount(row), 0).toFixed(2))
        };
    };


    procItemStockRegisterWithTotalAmount_ForAccount = () => {
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = {
                idCompany: this.state.idCompany,
                fromDate: this.state.requestDetails.fromDate,
                toDate: this.state.requestDetails.toDate
            };
            this.setState({ isLoading: true })
            this.dailyReportsServices.procItemStockRegisterWithTotalAmount_ForAccount(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    this.setState({ isLoading: false })
                    this.setState({ rowData: data }, () => {
                        this.setState({ sumRow: this.calculateSumRow() }); // Ensure sumRow updates
                    });
                } else {
                    this.setState({ isLoading: false })
                }
            });
        }
    };


    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }


    render() {
        return (
            <div className='account-stock-report'>
                <div className="data-display">
                    <div className="data-display-inner">
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[60%] mb-[10px]'>
                            <p className='mb-[5px] font-semibold text-blue text-[16px]'>Select date</p>
                            <div className='item-grp flex gap-[10px] items-end'>
                                <div className='input-grp w-full'>
                                    <label>From date</label>
                                    <input type='date' className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                        //id="userName"
                                        name="fromdate"
                                        value={this.state.requestDetails.fromDate}
                                        onChange={(event) => this.handleChange(event, "fromDate")}
                                    />
                                </div>
                                <div className='input-grp w-full'>
                                    <label>To date</label>
                                    <input type='date'
                                        value={this.state.requestDetails.toDate}
                                        className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`}
                                        onChange={(event) => this.handleChange(event, "toDate")}
                                    />
                                </div>
                                {this.state.isLoading ? (
                                    <button className='prm-btn h-fit ml-[10px] opacity-50 cursor-not-allowed' disabled>
                                        Loading...
                                    </button>
                                ) : (
                                    <button className='prm-btn h-fit ml-[10px]'
                                        onClick={() => { this.procItemStockRegisterWithTotalAmount_ForAccount() }}
                                    >Search</button>
                                )}
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[71.9vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item tracking details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pinnedBottomRowData={[this.state.sumRow]}
                                    rowClassRules={{
                                        "sum-row": (params) => params.node.rowPinned === "bottom"
                                    }}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AccountStockReport;
